import { render, staticRenderFns } from "./fishingParadise.vue?vue&type=template&id=46577744&scoped=true"
import script from "./fishingParadise.vue?vue&type=script&lang=js"
export * from "./fishingParadise.vue?vue&type=script&lang=js"
import style0 from "./fishingParadise.vue?vue&type=style&index=0&id=46577744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46577744",
  null
  
)

export default component.exports